import React, { useEffect, useRef, useState } from 'react'

import { useNavigate, useParams } from 'react-router-dom'
import { Button } from '@chakra-ui/react'
import SubAnchorBalanceInfo from 'components/SubAnchorBalanceInfo'
import SubAnchorInfoCard from 'components/SubAnchorInfoCard'
import AddSubanchorModal from 'components/AddSubanchorModal'
import { useWallet } from 'contexts/WalletContext'
import { getAllSubAnchors } from 'services/Wallet/subAnchorService'

const SubAnchorDetailPage = () => {
  const { id, dsa_code } = useParams()
  const navigate = useNavigate()
  const { wallet, setWallet } = useWallet()
  const fetchInFlightRef = useRef(null)
  const [showEditModal, setShowEditModal] = useState(false)
  const [editData, setEditData] = useState(null)
  const [cardRefreshKey, setCardRefreshKey] = useState(0)



  const handleBackToList = () => {
    navigate('/financedashboard')
  }

  const handleBack = () => {
    navigate(`/partner-detail/${id}`)
  }

  useEffect(() => {
    if (!id || !dsa_code) return
    const requestKey = `subanchor-detail-${id}-${dsa_code}`
    if (fetchInFlightRef.current === requestKey) return
    fetchInFlightRef.current = requestKey

    const fetchAndSetWallet = async () => {
      try {
        const res = await getAllSubAnchors(id, 1, 5)
        if (res?.items?.length > 0) {
          const matched = res?.items?.find(sa => sa.dsa_code === dsa_code)
          if (matched) {
            setWallet(prev => ({
              ...prev,
              subAnchorWalletId: matched.wallet_id,
              dsa_code: matched.dsa_code,
              dsaId: matched.id,
            }))
          }
        }
      } catch (err) {
        console.error("Error fetching sub anchors:", err)
      } finally {
        fetchInFlightRef.current = null
      }
    }

    fetchAndSetWallet()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id, dsa_code])

  const handleEditClick = (info) => {
    setEditData({
      walletId: wallet?.subAnchorWalletId,
      code: info.code,
      mobile: info.mobile,
      email: info.email,
    })
    setShowEditModal(true)
  }

  const handleEditSuccess = () => {
    setCardRefreshKey((k) => k + 1)
  }

  return (
    <div className="bg-[#F3F4F6] h-screen">
      <div className="flex items-center gap-3 mx-8 my-4">
        <Button size="sm" bgColor={"#233B85"}
          color={"white"} onClick={handleBackToList}>
          ← Anchor List
        </Button>
        <Button size="sm" variant="outline" borderColor={"#233B85"}
          color={"#233B85"} onClick={handleBack}>
          ← Back to Anchor
        </Button>
        <p className="font-semibold text-[20px]">
          Sub Anchor Details: {wallet?.dsa_code}
        </p>
      </div>

      <div className="bg-white mx-8 my-4 p-4 rounded-md shadow-sm">
        {wallet?.subAnchorWalletId ? (
          <>
            <SubAnchorInfoCard
              anchorId={id}
              walletId={wallet.subAnchorWalletId}
              onEditClick={handleEditClick}
              refreshTrigger={cardRefreshKey}
            />
            <SubAnchorBalanceInfo dsaId={wallet?.dsaId} walletId={wallet?.subAnchorWalletId} />
          </>
        ) : (
          <p className="mx-8 my-4 text-gray-500">Loading wallet info...</p>
        )}
      </div>

      <AddSubanchorModal
        isOpen={showEditModal}
        onClose={() => {
          setShowEditModal(false)
          setEditData(null)
        }}
        anchorId={id}
        onSuccess={handleEditSuccess}
        editData={editData}
      />
    </div>
  )
}

export default SubAnchorDetailPage
